<template>
  <div class="">
    <div class="head-title">客户群列表</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、统计企业员工创建的客户群列表、群主、创建时间、成员数、群聊状态等详细内容。
          </p>
          <p>2、可根据群聊名称和群标签进行查询搜索。</p>
          <p>
            3、点击群聊查看详情可查看具体群成员、入群方式、入群时间等详情信息，深入了解客户的需要，发现高价值客户，管理员也可为该群聊设置多个群聊标签。
          </p>
          <p>4、开通了内容存档功能才能统计群今日会话和历史会话。</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav style="display: flex; justify-content: space-between">
        <div>
          <span>
            <el-button style="margin-right: 2.4rem" type="primary" icon="el-icon-refresh" :loading="updateLoading"
              @click="getRenew">{{ loadingText }}</el-button>
          </span>
          <span class="">
            <el-select style="min-width: 24.0rem" v-model="label_group_id" filterable remote reserve-keyword clearable
              placeholder="请选择群标签搜索" :remote-method="remoteMethod" :loading="loading" @change="userTable"
              @focus="getTagList()">
              <el-option v-for="item in label_options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </span>
        </div>
        <div>
          <span style="width: 24.0rem; display: inline-flex" @click.stop="onSelectPerson">
            <el-input v-model="person.name" placeholder="选择群主" suffix-icon="el-icon-arrow-down" @change="clearD">
            </el-input>
          </span>
          <span>
            <el-input clearable style="width: 35.0rem; margin: 0 0 0 2.0rem" placeholder="请输入群名称搜索"
              prefix-icon="el-icon-search" v-model="input2" @change="userTable()">
              <el-button slot="append" type="primary" @click="userTable()">查询</el-button>
            </el-input>

          </span>
        </div>
      </nav>
      <div style="margin-top: 2.0rem">
        <el-table :data="tableData.data" border v-loading="tableLoading">
          <el-table-column style="width:11.11%" prop="name" label="群名称"></el-table-column>
          <el-table-column style="width:11.11%" prop="owner_name" label="群主"></el-table-column>
          <el-table-column style="width:11.11%" prop="gruop_count" label="群人数"></el-table-column>
          <el-table-column style="width:11.11%" prop="status" label="群状态"></el-table-column>
          <el-table-column prop="label_group_name" label="群标签" style="width:11.11%">
            <template slot-scope="scope">
              <div v-if="scope.row.isTagEmpty">
                {{ scope.row.label_group_name }}
              </div>
              <div v-else>
                <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.label_group_name" :key="index">{{ i
                }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="todayConversation" label="今日会话" style="width:11.11%">
            <template slot-scope="scope">
              <span style="color: #67c23a">
                {{ scope.row.todayConversation }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="historyConversation" label="历史会话" style="width:11.11%">
            <template slot-scope="scope">
              <span style="color: #67c23a">
                {{ scope.row.historyConversation }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" style="width:11.11%"></el-table-column>
          <el-table-column label="操作" width="170" fixed="right" >
            <template slot-scope="scope">
              <el-button @click="onToDetail(scope.row)" size="mini" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging">
        <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="userTable" />
      </div>
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="添加" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';

export default {
  name: "monitoring",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      label_group_id: [],
      label_options: [],
      label_list: [],
      tableData: {
        total: 0,
        data: [],
      },
      loading: false,
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      pageSize: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      updateLoading: false,
      loadingText: "同步客户群",
      input3: '',
      person: {},
      module: "",
      checkbox: false,
      tableLoading: true
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getTagList();
    this.userTable();
  },
  methods: {
    async getTagList(q = "") {
      const { data: res } = await this.axios({
        url: "/crm/LabelGroup/getList2",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: q,
        }),
      });
      this.label_options = res.data.map((item) => {
        return { value: `${item.id}`, label: `${item.tag_name}` };
      });
    },
    async remoteMethod(query) {
      this.loading = true;
      const label_list = await this.getTagList(query);
      this.loading = false;
    },
    onToDetail(row) {
      this.$router.push({
        name: "clientBaseDetail",
        query: {
          chat_id: row.chat_id,
        },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getClientBaseList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            label_group_id: this.label_group_id,
            name: this.input2,
            userid: this.person.userid,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const isTagEmpty = i.label_group_name.includes("暂无");
            i.isTagEmpty = isTagEmpty;
            if (!isTagEmpty) {
              i.label_group_name = i.label_group_name.split(",");
            }
          });
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Assistant/getClientBaseList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            account_id: this.tooken.id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/addSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,

            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },
    async getRenew() {
      // this.updateLoading = true;
      // // 拉取更新数据
      // const ws = new WebSocket("wss://api.weijub.com:4431");
      //
      // ws.onopen = () => {
      //   console.log("连接成功");
      //   this.loadingText = "数据拉取中";
      //   ws.send(
      //     JSON.stringify({
      //       uid: this.tooken.account_id,
      //       type: "groupchat",
      //     })
      //   );
      // };
      // ws.onmessage = (e) => {
      //   this.updateLoading = false;
      //   this.loadingText = "同步客户群";
      //   this.$message.success("同步成功");
      //   this.tableData.data = [];
      //   this.userTable();
      // };
      this.axios
          .post(
              "https://api.weijub.com/home/Wxwork/updateGroupchatList",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.tableData.data = [];
              this.userTable();
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
          })
    },
    clearD() {
      if (this.person.name == "") {
        this.person.userid = "";
      }
      this.userTable()
    },
    onSelectPerson() {
      this.module = "getClientBaseListGroupSop";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
      this.userTable();
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}

nav {
  width: 100%;
}

.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
</style>
